import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';

export default function ArchiveText() {

    
    return (

        <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Raw data files from" 
            headline_grey = "genome sequencing -"
            headline_p2 = "secure and available"

            text1 = "In this section you find all your personal genome raw data files in case you need them for further processing and analysis. Available filetypes are R1/R2 fasta, BAM, CRAM and vcf format."
            text2 = "Be aware that some files are very large (up to 70GB) and that it takes bandwith, time and capacity to download."

        />
    }/>
            
    )
}